import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '@shared/services/common-service';
import {
  NotaFiscalEntradaUltimasEmitenteResponse,
} from '@shared/services/responses/repo-dfe/nota-fiscal-entrada-ultimas-emitente.response';

/** Controller NotaFiscalEntradaLista da API RepoDFe. */
@Injectable({ providedIn: 'root' })
export class NotaFiscalEntradaListaService extends CommonService {
  private readonly apiUrl: string = environment.urlApiRepoDFe + 'NotaFiscalEntradaLista';

  constructor(private httpClient: HttpClient) {
    super();
  }

  /** As últimas notas de entrada em que a pessoa é o emitente. */
  public getUltimasDoEmitente(idPessoa: number, quantidade: number = 10): Observable<NotaFiscalEntradaUltimasEmitenteResponse> {
    return this.httpClient
      .get<NotaFiscalEntradaUltimasEmitenteResponse>(
        `${this.apiUrl}/emitente/idPessoa/${idPessoa}/ultimas?quantidade=${quantidade}`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
